import React, { useRef } from "react"
import ClientReportSprintSummary from "./ClientReportSprintSummary.controller"
import ClientReportSprintTimeConsumption from "./ClientReportSprintTimeConsumption.controller"
import GeneralSprintProgress from "../Development/GeneralSprintProgress.controller"
import ClientSprintBudgetState from "../Development/ClientSprintBudgetState.controller"
import ClientSprintDetailedEstimation from "../Development/ClientSprintDetailedEstimation.controller"
import ClientSprintHorizonEstimation from "../Development/ClientSprintHorizonEstimation.controller"
import {
  CLIENT_SPRINT_CARD_MODES,
  CLIENT_SPRINT_CARD_SIZE_MODES,
} from "../../../../consts/modules/clientReport.consts"
import ClientBurnchart from "../Burnchart/ClientBurnchart.controller"

const CLIENT_REPORT_DOWNLOAD_CONFIG = {
  SUMMARY: {
    // label: "",
    component: ClientReportSprintSummary,
    visible: true,
  },
  HOUR_CONSUMPTION: {
    label: "Consumo de horas",
    component: ClientReportSprintTimeConsumption,
    visible: true,
  },

  POINT_PROGRESS: {
    label: "Avance del alcance actual",
    component: GeneralSprintProgress,
    visible: true,
  },

  DETAILED_ESTIMATION: {
    label: "Estimación detallada",
    component: ClientSprintDetailedEstimation,
    visible: true,
  },
  BURNCHART: {
    label: "Burnchart",
    component: ClientBurnchart,
    visible: true,
  },
  HORIZON_ESTIMATION: {
    label: "Horizonte de estimaciones",
    component: ClientSprintHorizonEstimation,
    visible: true,
  },
  BUDGET_STATE: {
    label: "Estado del presupuesto",
    component: ClientSprintBudgetState,
    visible: true,
  },
}
const ClientReportDownload = ({
  sprintData,
  refresh,
  triggerRefresh,
  visibleMap,
  setVisibleMap,
  period,
  extraData,
}) => {
  const isVisible = (path) =>
    path.split("-").reduce((acc, key) => acc?.[key], visibleMap)

  const hasAnyVisibleChild = (configObj, parentKey) =>
    Object.keys(configObj).some((key) =>
      isVisible(parentKey ? `${parentKey}-${key}` : key)
    )

  const toggleVisibility = (path) => {
    setVisibleMap((prev) => {
      const keys = path.split("-")
      const next = structuredClone(prev)

      const parentObject = keys
        .slice(0, -1)
        .reduce((currentObj, key) => currentObj[key], next)

      const targetKey = keys.at(-1)

      parentObject[targetKey] = !parentObject[targetKey]

      return next
    })
  }

  const getLabelFromConfig = (path) => {
    return path
      .split("-")
      .reduce((acc, key) => acc?.[key], CLIENT_REPORT_DOWNLOAD_CONFIG)?.label
  }
  const getNestedConfig = (obj, keyPath) =>
    keyPath.split("-").reduce((acc, key) => acc?.[key], obj)

  const chartRefs = useRef({})
  const renderReportComponents = (
    configObj,
    parentKey = "",
    originalObj,
    chartRefs
  ) =>
    Object.entries(configObj).flatMap(([key, config]) => {
      const compoundKey = parentKey ? `${parentKey}-${key}` : key

      if (config?.component && isVisible(compoundKey)) {
        const Component = config.component
        const parentConfig = getNestedConfig(originalObj, parentKey)
        const isCompact = parentConfig && Object.keys(parentConfig).length === 1
        const parentVisibility =
          parentKey && isVisible(parentKey) ?
            Object.values(
              parentKey.split("-").reduce((acc, k) => acc?.[k], visibleMap)
            ).filter(Boolean)
          : []

        const isSingleInGroup = parentVisibility.length === 1

        const extraProps = {}
        if (config?.component) {
          const keyForRef = compoundKey
          chartRefs.current[keyForRef] =
            chartRefs.current[keyForRef] || React.createRef()
          extraProps.refChart = chartRefs.current[keyForRef]
          extraProps.chartRefs = chartRefs
        }

        return (
          <Component
            key={compoundKey}
            sprintData={sprintData}
            selectedPeriod={sprintData}
            period={period}
            refresh={refresh}
            triggerRefresh={triggerRefresh}
            mode={CLIENT_SPRINT_CARD_MODES.VIEW_ONLY}
            sizeMode={CLIENT_SPRINT_CARD_SIZE_MODES.LONG}
            visibleMap={visibleMap}
            onToggleSection={toggleVisibility}
            getSectionLabel={getLabelFromConfig}
            extraData={extraData}
            {...extraProps}
          />
        )
      }

      if (typeof config === "object" && !config.component) {
        if (!hasAnyVisibleChild(config, compoundKey)) {
          return null
        }
        return (
          <div key={compoundKey} className="flex gap-3 flex-wrap">
            {renderReportComponents(
              config,
              compoundKey,
              originalObj,
              chartRefs
            )}
          </div>
        )
      }

      return []
    })

  return (
    <div className="flex flex-column gap-3">
      {renderReportComponents(
        CLIENT_REPORT_DOWNLOAD_CONFIG,
        "",
        CLIENT_REPORT_DOWNLOAD_CONFIG,
        chartRefs
      )}
    </div>
  )
}

export default ClientReportDownload
